<app-header></app-header>
<app-resume-step></app-resume-step>
<div class="container mx-auto">
  <app-info-top></app-info-top>
  <app-question
    [question]="question"
    [popupInfoHA]="question.popupInfoHA"
    [local]="true"></app-question>

  <div class="flex clickable-card-parent flex-wrap justify-center gap-4 mb-[3rem]">
    @for(item of formRoomArea.controls; track $index) {
    <div
      class="clickable-card flex flex-col justify-center w-full text-center items-center cursor-pointer"
      (click)="onRoomAreaSelected(item.controls.value.value)"
      (keydown)="onRoomAreaSelected(item.controls.value.value)"
      [ngClass]="item.controls.selected.value ? 'active' : 'inactive'">
      <div [class]="item.controls.class.value"></div>
      <div class="flex flex-row items-center pb-8 place-content-between px-6">
        <p class="mr-2">{{ item.controls.label.value }}</p>
      </div>
    </div>
    }
  </div>

  <div class="container mx-auto h-28 md:h-40">
    <app-footer class="footer"></app-footer>
  </div>
  <app-web-callback></app-web-callback>

  <app-web-callback-popup
    [show]="displayModal"
    (cancel)="cancel()"
    [content]="contentWebCallBackPopup"></app-web-callback-popup>
</div>
